import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import { TOKENS } from '../ui/dashboard-primitives'

/**
 * Inline markdown for AI-generated prose (milestone, priorities, strategy,
 * signals). `**bold**` becomes a cream emphasis; the paragraph wrapper is
 * dropped so it drops straight into a surrounding <p>/<span>. `boldMono`
 * matches the prototype's mono emphasis in the priorities list.
 */
export function Md({ children, boldMono = false }: { children: string; boldMono?: boolean }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkBreaks]}
      components={{
        p: ({ children }) => <>{children}</>,
        a: ({ children }) => <>{children}</>,
        em: ({ children }) => <i>{children}</i>,
        strong: ({ children }) => (
          <b
            style={{
              color: TOKENS.cream,
              fontWeight: 600,
              ...(boldMono ? { fontFamily: 'var(--font-mono)', fontSize: '0.9em' } : {}),
            }}
          >
            {children}
          </b>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
